import { IsInt, IsNotEmpty, IsObject, IsOptional, IsString, IsUUID, Min } from 'class-validator';

export class CreateFeaturedImageDto {
	@IsString()
	@IsOptional()
	title?: string;

	@IsInt()
	@Min(0)
	order: number;

	@IsString()
	@IsNotEmpty()
	img_parent_id: string;

	@IsOptional()
	@IsObject()
	img_variants?: Record<string, string>;

	@IsString()
	@IsOptional()
	image_url?: string;
}

export class UpdateFeaturedImageDto {
	@IsUUID('4')
	@IsNotEmpty()
	id: string;

	@IsInt()
	@Min(0)
	@IsOptional()
	order?: number;

	@IsString()
	@IsOptional()
	image_url?: string;
}
